import './CompareWorkshops.css';
import CompareWorkshopsRow from './CompareWorkshopsRow';
import CompareWorkshopsPublicationAnalysisRow from './CompareWorkshopsPublicationAnalysisRow';

const CompareWorkshopsActivity3 = ({ comparedWorkshops, comparedWorkshopDetails }) => {
    
    return (
        <div className='mb-6'>
            <CompareWorkshopsRow
                title="Needs per stakeholder group"
                property="reports.text_activity_3_needs"
                comparedWorkshops={comparedWorkshops}
                workshopDetails={comparedWorkshopDetails}
            />
            <CompareWorkshopsRow
                title="Offers per stakeholder group"
                property="reports.text_activity_3_offers"
                comparedWorkshops={comparedWorkshops}
                workshopDetails={comparedWorkshopDetails}
            />
            <CompareWorkshopsRow
                title="How stakeholders want Benchmarks to support"
                property="reports.text_activity_3_BENCHMARKS"
                comparedWorkshops={comparedWorkshops}
                workshopDetails={comparedWorkshopDetails}
            />
            <CompareWorkshopsPublicationAnalysisRow
                title="Analysis summary: stakeholder needs"
                diagramKey="needs"
                comparedWorkshops={comparedWorkshops}
            />
        </div>
    );
};

export default CompareWorkshopsActivity3;
